import config from '../../../config'
import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import { BookingSource, IBooking } from '../../../pages/bookings-container/share-type'
import YesOrNoTag from '../../common/YesOrNoTag'
import { Button, Descriptions } from 'antd'

const { guavapassUrl } = config

interface IProps {
  booking: IBooking
}

const BookingDescription = (props: IProps) => {
  const { booking } = props

  return (
    <Descriptions
      title={`${translate('navBar.booking')}#${booking.id}`}
      column={1}
      bordered
      extra={<Button disabled>{translate('edit')}</Button>}
    >
      <Descriptions.Item label={translate('booking.user')}>
        <Button type="link" href={`${guavapassUrl}/admin/users/${booking.user.id}`}>
          User#{booking.user.id} {booking.user.firstName}
        </Button>
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.lesson')}>
        <Button type="link" href={`${guavapassUrl}/admin/lessons/${booking.lesson.id}`}>
          {booking.lesson.id}
        </Button>
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.entryTime')}>
        {booking.entryTime}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.isValid')}>
        <YesOrNoTag value={booking.isValid} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.noShow')}>
        <YesOrNoTag value={booking.noShow} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.completed')}>
        <YesOrNoTag value={booking.completed} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.notified')}>
        <YesOrNoTag value={booking.notified} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.cancelled')}>
        <YesOrNoTag value={booking.cancelled} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.cancelledBy')}>
        {booking.cancelledBy}
      </Descriptions.Item>
      <Descriptions.Item label={translate('createdAt')}>
        {getDateTime(booking.createdAt)}
      </Descriptions.Item>
      <Descriptions.Item label={translate('updatedAt')}>
        {getDateTime(booking.updatedAt)}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.ref')}>{booking.ref}</Descriptions.Item>
      <Descriptions.Item label={translate('booking.lateCancelled')}>
        <YesOrNoTag value={booking.lateCancelled} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.externalProvider')}>
        {booking.externalProviderId}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.pending')}>
        <YesOrNoTag value={booking.pending} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.studioNoShow')}>
        <YesOrNoTag value={booking.studioNoShow} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.studioNoShowAt')}>
        {booking.studioNoShowAt ? getDateTime(booking.studioNoShowAt) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.source')}>
        {booking.source ? (BookingSource[booking.source] ?? '') : ''}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.studioConfirmedAttendance')}>
        <YesOrNoTag value={booking.studioConfirmedAttendance} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.attendanceMarkedAt')}>
        {booking.attendanceMarkedAt ? getDateTime(booking.attendanceMarkedAt) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.earlyVisit')}>
        <YesOrNoTag value={booking.earlyVisit} />
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.studioSignInTime')}>
        {booking.studioSignInTime ? getDateTime(booking.studioSignInTime) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={translate('booking.studioSignOutTime')}>
        {booking.studioSignOutTime ? getDateTime(booking.studioSignOutTime) : ''}
      </Descriptions.Item>
    </Descriptions>
  )
}

export default BookingDescription
